"use client";

import ServiceTitle from "@/shared/app/ui/text/ServiceTitle";
import { motion, Variants } from "framer-motion";
import Image from "next/image";

const programData = [
  {
    title: "[기초교육]",
    img: "/assets/images/page/service/weslo/program1.png",
    list: ["장애인 보행권", "자원조사 방법론", "온라인 지도 사용법"],
    numberColor: "#EC6C50",
  },
  {
    title: "[팀별활동]",
    img: "/assets/images/page/service/weslo/program2.png",
    list: ["경사로 설치 허락", "경사로 설치", "위치데이터 등록"],
    numberColor: "#2B9E4A",
  },
  {
    title: "[소감나누기]",
    img: "/assets/images/page/service/weslo/program3.png",
    list: ["활동 돌아보기", "수료증 수여", "경사로 위치 홍보"],
    numberColor: "#5346B0",
  },
];

const containerVariants: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};
const numberBgColors = ["#EC6C50", "#2B9E4A", "#7866AC"];
export default function ProgramSection() {
  return (
    <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-14 md:py-16 xl:py-20">
      {/* 프로그램 타이틀  */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
      >
        <div className="text-center flex flex-col justify-center items-center mb-5">
          <span
            className="text-[#EC6C50] text-base md:text-2xl mb-8 sm:mb-10 md:mb-20 flex"
            style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
          >
            program
          </span>
          <p
            className="text-2xl sm:text-3xl md:text-5xl text-[#353535] leading-8  sm:leading-12 md:leading-15 text-center"
            style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
          >
            입간판 경사로 프로그램
          </p>
        </div>
        <motion.p
          className="mt-5 md:mt-8 text-base md:text-xl xl:text-2xl leading-6  md:leading-9 tracking-tight text-[#495368] text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
          viewport={{ once: true, amount: 0.3 }}
          style={{ fontFamily: '"pre-Medium", sans-serif' }}
        >
          실제로 경사로 사용이 될 수 있도록, <br />
          맛집과 핫플레이스를 발굴하여 경사로를 함께 설치하고,
          <br />
          활용할 수 있도록 지원하는 프로그램입니다
        </motion.p>
      </motion.div>
      <motion.div
        className="flex flex-col md:flex-row space-y-5 md:space-y-0 md:space-x-4 xl:space-x-20 mt-15 md:mt-30 mb-20"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {programData.map((program, idx) => (
          <motion.div
            key={idx}
            className="flex-1 flex flex-col items-center"
            variants={itemVariants}
          >
            {/* 타이틀 */}
            <div
              className="text-base md:text-xl text-center bg-[#484273] w-full text-white py-1.5 md:py-3 px-3 leading-7 md:leading-9 rounded-t-2xl"
              style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
            >
              {program.title}
            </div>

            {/* 이미지 */}
            <div className="relative w-full flex-1 aspect-[16/7] md:aspect-[16/9]  overflow-hidden shadow-md rounded-b-2xl">
              <Image
                src={program.img}
                alt={program.title}
                fill
                className="object-cover object-center"
              />
            </div>

            {/* 리스트 */}
            <ul className="mt-4 md:mt-6 space-y-3 w-full text-left">
              {program.list.map((item, i) => (
                <li
                  key={i}
                  className="flex items-center space-x-4 bg-[#F7F6FA] px-5 xl:px-8 py-2.5 rounded-full  duration-300"
                >
                  <span
                    className="flex items-center justify-center w-6 h-6 md:w-8 md:h-8 rounded-lg text-white flex-shrink-0 text-sm md:text-base"
                    style={{
                      backgroundColor: program.numberColor,
                      fontFamily: '"paperlogy-Medium", sans-serif',
                    }}
                  >
                    {i + 1}
                  </span>
                  <p
                    className="text-base md:text-lg  text-[#3C3C3C]"
                    style={{ fontFamily: '"paperlogy-Medium", sans-serif' }}
                  >
                    {item}
                  </p>
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
